const en = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Discovery Source Name',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'User Id',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'Service Now Url',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Password',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Invalid Url',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Discovery Frequency',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Prompt users to answer knowledge-based authentication (KBA) questions.',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Discover your apps and workloads through one of these popular discovery sources. You will unlock benefits like prefilled details, prioritized recommendations, and a full view of onboarded status.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Back',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Setup Discovery',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Coming Soon...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Learn More',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    "Enter your application credentials to establish a connection. Once the connection is successful, you'll be able to import data.",
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Something went wrong while loading the page.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Try refreshing, or check back later. If the issue persists, contact your administrator.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Reload',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Connection Settings',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI Classes***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Attribute Mapping',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Connection Details',
  'INTEGRATIONS.BUTTON.SAVE': 'Save',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Select',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Create New Connection',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Use This Connection',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow Saved!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Your connection to the discovery source ServiceNow has been successfully tested and saved. Import data to finalize setting up discovery. You may skip ...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Import Assets',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Skip for Now',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Once the import starts, it cannot be canceled',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Guide Me',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Select Existing Connection',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Connection Name',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'We discovered {total, plural, one {an} other {#}} existing connection configuration:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Start Import',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Importing data from Excel file. Please wait...',
  'INTEGRATIONS.TRY.AGAIN': 'Try Again',
  'INTEGRATIONS.CLOSE': 'Close',
  'INTEGRATIONS.ERROR.CONNECTION': 'Connection error. Please try again.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'You can exit the page while waiting. We will notify you once the process is complete.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Import Discovery Source',
  'INTEGRATIONS.FILEUPLOAD.HEADING': 'Import your discovery source from a file',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Download Sample File',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Discovery Source Name',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Enter file name',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Please enter a valid name. Only letters, numbers, and select symbols are allowed.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Uploading...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Continue',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Here are the first 10 records from the XLSX file uploaded.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Mandatory Header Missing',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Column Errors Detected',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Please fix the issues before proceeding to data import.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Exclude from import',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Application Onboarding Confirmation',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'We’ve identified the application type. Please confirm if this is the right application type you’re onboarding.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    "The application type you're onboarding is {applicationName}",
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'No, select from an application list',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    "Yes, I'm onboarding",
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Integrations',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'Add Integration',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'No results found for',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'No',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'integrations found.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'No hidden integrations available.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Applications Discovered',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Owner:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Last discovered on',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Connection Failed',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Users have access',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Discovery Source',
  'INTEGRATIONS.BUTTON.ENABLE': 'Enable',
  'INTEGRATIONS.BUTTON.DISABLE': 'Disable',
  'INTEGRATIONS.ENABLING': 'Enabling',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Discovery',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Re-upload',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Onboard',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Hide',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Unhide',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': 'Discovery configuration tabs',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Discard unsaved changes?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'You have unsaved changes. Changes will be lost if you continue.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Discard Changes',
  'INTEGRATIONS.BUTTON.CANCEL': 'Cancel',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Save Error',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': 'Go back to previous page',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Application icon',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Run Manually',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': 'Disabling Failed',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'Enabling Failed',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Disabled successfully.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'Enabled successfully.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Another import is currently in progress.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Assets are currently being imported by another process. Please try again later.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': 'Importing Failed',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS': 'Importing Assets from ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'You can exit the page while waiting. We’ll notify you once the process is complete.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Add new attribute mapping row',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Add Attribute',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Empty)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Delete this mapping',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow Field',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt Field',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Search ServiceNow attribute',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Search Saviynt attribute',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Custom)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Save failed',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Scheduling Configuration',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'at {timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Repeat On',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Repeat On Days',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Repeat Every',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Enter interval',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Repeat interval in number of days, weeks, or months',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Day',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Week(s)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Month',
  'INTEGRATIONS.DAYS.SUN': 'Sun',
  'INTEGRATIONS.DAYS.MON': 'Mon',
  'INTEGRATIONS.DAYS.TUE': 'Tue',
  'INTEGRATIONS.DAYS.WED': 'Wed',
  'INTEGRATIONS.DAYS.THU': 'Thu',
  'INTEGRATIONS.DAYS.FRI': 'Fri',
  'INTEGRATIONS.DAYS.SAT': 'Sat',
  'INTEGRATIONS.BUTTON.DISABLING': 'Disabling',
  'INTEGRATIONS.BUTTON.SAVED': 'Saved',
  'INTEGRATIONS.BUTTON.SAVING': 'Saving',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': 'Are you sure you want to disable ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'By disabling the discovery source, asset import will be stopped and you won’t be able to configure the source.',
  'INTEGRATIONS.DISCOVERY.HERE': 'here',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'Your discovery source has been successfully created, but the connection to ServiceNow has failed. To start importing assets, please update the connection details on the discovery source configuration page ',
};

export default en;
